import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BreakService {
  onBreak = signal(false);


  update(v) {
    this.onBreak.set(v);
  }
}
